var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCoordinate),expression:"showCoordinate"}],staticClass:"roy-editor-coordinate",style:(_vm.coordinateStyle)},[_vm._v(" "+_vm._s(_vm.left)+","+_vm._s(_vm.top)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }